/** @jsx jsx */
import { graphql } from 'gatsby';
import deepMerge from 'lodash/merge';
import { jsx } from 'theme-ui';
import ExhibitorsPage from '../components/ExhibitorsPage/ExhibitorsPage';

export default function ExhibitorsTemplate({
  data: {
    event,
    firstExhibitors,
    exhibitors,
    site: { siteMetadata },
  },
  pageContext,
  location,
  navigate,
}) {
  const { filterSeekingDistribution, filterHasDistribution } = event || {};
  // Enrich the first exhibitors with better images and base64 previews.
  const combinedExhibitors = exhibitors.nodes?.map((exhibitor, index) => {
    const refinedData = firstExhibitors?.nodes[index];
    if (!refinedData) return exhibitor;
    // HEADSUP: We don't need to care about mutating the exhibitor here,
    // but it can be surprising that the original data is now changed too when inspecting.
    return deepMerge(exhibitor, refinedData);
  });

  return (
    <ExhibitorsPage
      {...pageContext}
      // Make sure the page is remounted on a different href (i.e. a different query).
      // QUESTION: Why is this actually necessary? Because of the page's state?
      // key={location.href}
      event={event}
      exhibitors={combinedExhibitors}
      siteTitle={siteMetadata.title}
      facetConfig={{
        filterSeekingDistribution,
        filterHasDistribution,
        ...pageContext,
      }}
      location={location}
      navigate={navigate}
    />
  );
}

export const pageQuery = graphql`
  query ExhibitorsTemplate(
    $filter: ExhibitorFilterInput
    $sort: ExhibitorSortInput
    $locale: String
  ) {
    event(locale: { eq: $locale }) {
      filterHasDistribution
      filterSeekingDistribution
    }
    firstExhibitors: allExhibitor(filter: $filter, sort: $sort, limit: 10) {
      nodes {
        ...ExhibitorsPage_first
      }
    }
    exhibitors: allExhibitor(filter: $filter, sort: $sort) {
      nodes {
        ...ExhibitorsPage
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;
